import * as Sentry from '@sentry/vue';
import type {App} from 'vue';
import {Brand} from './brand';

export type SentryPluginConfig = {
	project: string;
	authToken: string;
};

const getSentryDsn = () => {
	switch (import.meta.env.VITE_DFN_BRAND) {
		case Brand.CAIWAY:
			return import.meta.env.VITE_SENTRY_CAIWAY_DSN;
		case Brand.DELTA:
			return import.meta.env.VITE_SENTRY_DELTA_DSN;
		case Brand.DELTA_CORPORATE:
			return import.meta.env.VITE_SENTRY_DELTA_COPRORATE_DSN;
		default:
			return null;
	}
};

export const getSentryPluginOptions = (brand: string, config: SentryPluginConfig, buildDir: string) => ({
	org: 'eleven',
	project: config.project,
	release: `dfn-${process.env.VITE_RELEASE_VERSION}`,
	url: process.env.SENTRY_BASE_URL,
	include: buildDir,
	urlPrefix: '~/frontend-build/assets',
	dist: brand,
	authToken: config.authToken
});

export const initSentry = (apps: Array<App<Element>>) => {
	const dsn = getSentryDsn();
	const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT;

	if (dsn && environment) {
		Sentry.init({
			app: apps,
			dsn,
			environment,
			release: `dfn-${import.meta.env.VITE_RELEASE_VERSION}`,
			integrations: [
				new Sentry.BrowserTracing({
					tracePropagationTargets: JSON.parse(import.meta.env.VITE_SENTRY_TRACE_TARGETS)
				})
			],
			tracesSampleRate: 1.0
		});
	}
};
